import { Box, Tabs, Tab } from "@mui/material";
import { useTranslation } from "next-i18next";
import { Typography } from "src/components-mui/base/typography/typography";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { WfPopover } from "src/components-mui/base/wf-popover/wf-popover";
import { useCertificateBoxContext } from "src/components-mui/pages/detail/certificate-box/context";
import { certificateRatio } from "src/components-mui/pages/detail/certificate-box/utils";
import { getTabsListCustomVariantStyles } from "src/components-mui/tabs/tabs-list.styles";

const RATIO_TAB_BAR_TEST_ID = "ratio-tab-bar";
const RATIO_TAB_BAR_BUTTON_TEST_ID = "ratio-tab-bar-button";

export const CBRatioTabBar = () => {
    const { data, selectedCertificate, updateSelectedCertificate } = useCertificateBoxContext();
    const { certificates } = data;
    const { t } = useTranslation("wf-detail");

    return (
        <Box data-test-id={RATIO_TAB_BAR_TEST_ID}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", pb: 1 }}>
                <Typography
                    sx={{
                        fontSize: "xs",
                    }}
                >
                    {t("certificate.ratio")}
                </Typography>
                <WfPopover
                    content={data.tooltips.ratio!.content}
                    link={data.tooltips.ratio!.link}
                    PopoverTrigger={<PopoverButtonIconInfo ariaLabel={t("certificate.ratio")} sx={{ ml: 1 }} />}
                />
            </Box>

            <Tabs
                value={selectedCertificate.isin}
                onChange={(_, value) => updateSelectedCertificate(value as string)}
                sx={getTabsListCustomVariantStyles("full")}
                aria-label={t("certificate.ratio")}
            >
                {certificates.map(certificate => (
                    <Tab
                        key={certificate.isin}
                        value={certificate.isin}
                        label={certificateRatio(certificate.exchangeRatioMultiplier)}
                        aria-label={`${t("certificate.ratio")} ${certificateRatio(certificate.exchangeRatioMultiplier)}`}
                        data-test-id={RATIO_TAB_BAR_BUTTON_TEST_ID}
                    />
                ))}
            </Tabs>
        </Box>
    );
};
